import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EndNpsComponent } from './end-nps/end-nps.component';
import { NpsComponent } from './nps/nps.component';
import { CustomQuestionsPageComponent } from './custom-questions-page/custom-questions-page.component';

const routes: Routes = [
  { path: 'nps/:guid', component: NpsComponent, pathMatch: 'full'},
  { path: 'nps/questions/:guid', component: CustomQuestionsPageComponent, pathMatch: 'full'},
  { path: 'nps/end-nps/:guid', component: EndNpsComponent, pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NpsRoutingModule { }
